<template>
  <div class="mescan-figure">
    <div class="mescan-figure__halo" aria-hidden="true" />
    <object ref="body" class="mescan-figure__image" type="image/svg+xml" data="/img/einmalig/meScanBody.svg" aria-hidden="true" tabindex="-1" @load="initialize" @error="unavailable = true">
      <span class="mescan-figure__fallback"><v-icon color="#89928d" size="80">mdi-human</v-icon></span>
    </object>
    <small v-if="unavailable">Körpergrafik nicht verfügbar</small>
  </div>
</template>
<script>
import { BODY_PARTS, meScanRating } from "@/services/mescanHealthData"

// Reuse the same Roody asset and region classes as UserMescanData.
// Scope every SVG lookup to this instance, including dialogs and previews.
const REGIONS = { trunk: ["abs", "chest", "belly"], rightArm: ["right-arm"], leftArm: ["left-arm"], rightLeg: ["right-leg"], leftLeg: ["left-leg"] }
export default {
  props: {
    segments: { type: Object, default: () => ({}) }, ratings: { type: Object, default: () => ({}) },
    activePart: { type: String, default: "" }, interactive: Boolean,
  },
  data: () => ({ unavailable: false }),
  watch: {
    segments: { deep: true, handler() { this.paint() } }, ratings: { deep: true, handler() { this.paint() } },
    activePart() { this.paint() }, interactive() { this.paint() },
  },
  beforeDestroy() { this.clearListeners() },
  methods: {
    document() { try { return this.$refs.body?.getSVGDocument?.() || this.$refs.body?.contentDocument || null } catch (_) { return null } },
    clearListeners() { (this.bodyListeners || []).forEach(([node, listener]) => node.removeEventListener("click", listener)); this.bodyListeners = [] },
    initialize() {
      this.clearListeners()
      const svg = this.document()
      if (!svg?.documentElement || svg.documentElement.localName !== "svg") { this.unavailable = true; return }
      this.unavailable = false
      svg.documentElement.setAttribute("preserveAspectRatio", "xMidYMid meet")
      svg.documentElement.style.width = "100%"; svg.documentElement.style.height = "100%"
      for (const [key, classes] of Object.entries(REGIONS)) for (const name of classes) {
        for (const node of svg.getElementsByClassName(name)) {
          const listener = () => { if (this.interactive && Number.isFinite(this.segments[key])) this.$emit("select", key) }
          node.addEventListener("click", listener); this.bodyListeners.push([node, listener])
        }
      }
      this.paint()
    },
    paint() {
      const svg = this.document()
      if (!svg) return
      const reduce = typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches
      for (const part of BODY_PARTS) for (const name of REGIONS[part.key]) {
        const available = Number.isFinite(this.segments[part.key])
        const rating = meScanRating("muscleMassKilograms", available ? this.ratings[part.key] : null)
        for (const node of svg.getElementsByClassName(name)) {
          node.setAttribute("fill", rating.index === null ? "#626966" : rating.color)
          node.style.fill = rating.index === null ? "#626966" : rating.color
          node.style.opacity = this.activePart && this.activePart !== part.key ? ".45" : "1"
          node.style.cursor = this.interactive && available ? "pointer" : "default"
          node.style.transition = reduce ? "none" : "fill 180ms ease, opacity 180ms ease"
        }
      }
    },
  },
}
</script>
<style scoped>
.mescan-figure { position: relative; isolation: isolate; display: flex; flex-direction: column; align-items: center; justify-content: center; min-width: 0; }
.mescan-figure__halo { position: absolute; z-index: -1; width: 100%; height: 62%; top: 19%; border-radius: 50%; background: radial-gradient(ellipse, #ffffff08, transparent 70%); }
.mescan-figure__image { display: block; width: 100%; height: 290px; border: 0; }
.mescan-figure__fallback { display: flex; align-items: center; justify-content: center; height: 100%; }
.mescan-figure small { font-size: 10px; line-height: 1.5; color: #929995; text-align: center; }
@media (max-width: 360px) { .mescan-figure__image { height: 254px; } }
</style>
